export { OwnershipFacet } from './OwnershipFacet';
